module.exports = "https://www.gc-qa.gnp.com.mx/646aa7e1d51239b8c416c7398d4e909b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/carrusel-06.gif
// module id = 8074
// module chunks = 0